import * as yup from 'yup';
import {
  REGEX_ZIPCODE,
  REGEX_ORGNR,
  REGEX_PHONE_NUMBER,
} from '@client/shared/utils/validation/regex';
import {
  FIRST_NAME,
  LAST_NAME,
  STREET_ADDRESS,
  ZIP_CODE,
  CITY,
  PHONE_NUMBER,
  EMAIL,
  COMPANY_NAME,
  SSN_ORG_NUMBER,
  PHONE_NUMBER_MIN_LENGTH,
  PHONE_NUMBER_MAX_LENGTH,
  INDIVIDUAL_TYPE,
} from '@client/definitions/formFieldNames';
import {
  ERROR_REQUIRED,
  ERROR_MAX_LENGTH_50,
} from '@client/definitions/errorMessages';
import { formFieldErrorTranslations } from '@client/translations/formFieldTranslations';

export const donateFundraiserSchema = () => {
  return yup.object().shape({
    [FIRST_NAME]: yup
      .string()
      .required('Du måste ange ett förnamn')
      .max(50, ERROR_MAX_LENGTH_50)
      .trim(),
    [LAST_NAME]: yup
      .string()
      .required('Du måste ange ett efternamn')
      .max(50, ERROR_MAX_LENGTH_50)
      .trim(),
    [STREET_ADDRESS]: yup
      .string()
      .required('Du måste ange en adress')
      .max(50, ERROR_MAX_LENGTH_50)
      .trim(),
    [ZIP_CODE]: yup
      .string()
      .required('Du måste ange ett giltigt postnummer')
      .matches(REGEX_ZIPCODE, formFieldErrorTranslations[ZIP_CODE]),
    [CITY]: yup
      .string()
      .required('Du måste ange en ort')
      .max(50, ERROR_MAX_LENGTH_50)
      .trim(),
    [PHONE_NUMBER]: yup
      .string()
      .min(5, formFieldErrorTranslations[PHONE_NUMBER_MIN_LENGTH])
      .max(15, formFieldErrorTranslations[PHONE_NUMBER_MAX_LENGTH])
      .matches(REGEX_PHONE_NUMBER, formFieldErrorTranslations[PHONE_NUMBER]),
    [EMAIL]: yup
      .string()
      .required('Du måste ange en giltig e-postadress')
      .email(formFieldErrorTranslations[EMAIL]),
    [COMPANY_NAME]: yup.string().when(INDIVIDUAL_TYPE, (val, schema) => {
      if (val === 'Company') {
        return schema
          .required('Ange ett företagsnamn')
          .max(50, ERROR_MAX_LENGTH_50)
          .trim();
      }
      return schema;
    }),
    [SSN_ORG_NUMBER]: yup.string().when(INDIVIDUAL_TYPE, (val, schema) => {
      if (val === 'Company') {
        return schema.matches(
          REGEX_ORGNR,
          formFieldErrorTranslations[SSN_ORG_NUMBER]
        );
      }
      return schema;
    }),
  });
};
